/* eslint-disable react/prop-types */
import React, { PureComponent } from 'react'

export default class Track extends PureComponent {
  render() {
    const { className, disabled, noop, included,
      vertical, offset, length, style } = this.props

    const positonStyle = vertical ? {
      bottom: `${offset}%`,
      height: `${length}%`
    } : {
      left: `${offset}%`,
      width: `${length}%`
    }

    const elStyle = {
      ...style,
      ...positonStyle
    }
    return included ? <div
      onMouseDown={disabled ? noop : this.onMouseDown}
      onMouseUp={disabled ? noop : this.onMouseUp}
      className={className} style={elStyle} /> : null
  }
}
